import { lighten } from "polished";
import styled, { css } from "styled-components";

type Props = {
  variant?: "primary" | "secondary";
  size?: "small" | "normal" | "large";
  fullWidth?: boolean;
};

export const StyledButton = styled.button<Props>`
  ${props => css`
    display: inline-block;
    width: ${props.fullWidth && "100%"};
    height: 48px;
    padding: 0 25px;
    color: #333;
    border: 1px solid transparent;
    background: transparent;
    font-weight: 600;
    font-size: 17px;
    cursor: pointer;
    user-select: none;

    &:hover {
      color: #333;
      background: #f3f3f3;
    }

    &:disabled,
    &:disabled:hover {
      color: #b2b2b2;
      background: #dddddd;
    }

    ${props.variant &&
    props.variant === "primary" &&
    css`
      background: var(--button-color);
      color: #fff;
      border-radius: 9999px;
      transition: var(--button-transition);

      &:hover {
        background: var(--button-color);
        color: #fff;
        transform: scale(1.07);
      }

      &:focus {
        outline: none;
        box-shadow: 0 0 0 2px var(--button-focus-ring);
      }

      &:disabled,
      &:disabled:hover {
        background: var(--button-disabled-color);
        border-color: var(--button-disabled-color);
        color: #fff;
        transform: none;
      }
    `};

    ${props.variant &&
    props.variant === "secondary" &&
    css`
      background: transparent;
      border: 1px solid var(--heading-color);
      color: var(--heading-color);
      border-radius: 9999px;
      transition: var(--button-transition);

      &:hover {
        background: transparent;
        border-color: var(--heading-color);
        color: var(--heading-color);
        transform: scale(1.07);
      }

      &:focus {
        outline: none;
        box-shadow: 0 0 0 2px var(--button-focus-ring);
      }

      &:disabled,
      &:disabled:hover {
        background: transparent;
        border-color: var(--button-outline-disabled-color);
        color: var(--button-outline-disabled-color);
        transform: none;
      }
    `};
  `};
`;

export const StyledLinkButton = StyledButton.withComponent("a");
